import type { OpayoBrowserInfo } from '../types';

export const buildBrowserInfo = (): OpayoBrowserInfo => ({
  acceptHeader: '*/*',
  javascriptEnabled: true,
  javaEnabled:
    typeof navigator !== 'undefined' && typeof navigator.javaEnabled === 'function'
      ? navigator.javaEnabled()
      : false,
  language: typeof navigator !== 'undefined' ? navigator.language : 'en-GB',
  colorDepth: typeof window !== 'undefined' ? window.screen.colorDepth || 24 : 24,
  screenHeight: typeof window !== 'undefined' ? window.screen.height || 0 : 0,
  screenWidth: typeof window !== 'undefined' ? window.screen.width || 0 : 0,
  timezoneOffset: new Date().getTimezoneOffset(),
  userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
  challengeWindowSize: 'FullScreen'
});
